import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type RelationUserBookDb = {
  userId: string;
  bookId: string;
}
const initial: RelationUserBookDb = {
  userId: '',
  bookId: ''
};

export type RelationUserBookDbHashType = {
  [key in string]: RelationUserBookDb;
}

export type RelationUserBookAddPayload = {
  id?: string;
} & RelationUserBookDb;
export type RelationUserBookUpdatePayload = {
  id: string;
} & { [P in keyof RelationUserBookDb]?: RelationUserBookDb[P] };

export type RelationUserBookDbState = {
  relationUserBooks: RelationUserBookDbHashType;
}

export const  generateRelationUserBookId = () : string =>  generateId('rub');
let initialState: RelationUserBookDbState = { relationUserBooks: {} };
const key = 'relationUserBooks';

const relationUserBookDbSlice = createSlice({
  name: 'relationUserBookDb',
  initialState,
  reducers: {
    initializeRelationUserBooks(state: RelationUserBookDbState) {
      state.relationUserBooks = {};
    },
    addRelationUserBook(state: RelationUserBookDbState, action: PayloadAction<RelationUserBookAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateRelationUserBookId();
      state.relationUserBooks[id] = obj;
      saveData(key, id, obj);
    },
    updateRelationUserBook(state: RelationUserBookDbState, action: PayloadAction<RelationUserBookUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.relationUserBooks[id] === undefined) {
        console.log(`*** RelationUserBook not found: ${id}`);
      } else {
        const newData = { ...state.relationUserBooks[id], ...obj };
        state.relationUserBooks[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteRelationUserBook(state: RelationUserBookDbState, action: PayloadAction<RelationUserBookUpdatePayload>) {
      const id = action.payload.id;
      delete state.relationUserBooks[id];
      deleteData(key, id);
    },
    saveRelationUserBooks(state: RelationUserBookDbState) {
      saveAllData(key, state.relationUserBooks);
    },
    signUpRelationUserBooks(state: RelationUserBookDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.relationUserBooks, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: RelationUserBookDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.relationUserBooks = updatedValues;
      if (changed) saveAllData(key, state.relationUserBooks);
    })
  }
})

export const { initializeRelationUserBooks, addRelationUserBook, updateRelationUserBook, deleteRelationUserBook, saveRelationUserBooks, signUpRelationUserBooks } = relationUserBookDbSlice.actions;
export default relationUserBookDbSlice.reducer;
